module.exports = __webpack_public_path__ + "media/images/icons/Hvezdicky/starFilled-073ae3418347ba3ee5f4c1bb61732573.png";